import { HomeMainCompProps } from "../../../components/home-main-comp/home-main.comp";
import coverImage from "../../../assets/images/covers/mini/as-ig.png";

/* FAKE ICONS */
import adobeXdIcon from "../../../assets/icons/skills/adobe-xd.png";
import figmaIco from "../../../assets/icons/skills/figma-1.png";
import libreOfficeDrawIco from "../../../assets/icons/skills/libre-office-draw.png";
import psIco from "../../../assets/icons/skills/photoshop-cc-4.png";
import illustratorIco from "../../../assets/icons/skills/adobe-illustrator-cc-2019.png";
import zBrushIco from "../../../assets/icons/skills/zbrush.png";
import sketchupIco from "../../../assets/icons/skills/sketchup.png";
import premiereProIco from "../../../assets/icons/skills/premiere-cc.png";
import afterEffectIco from "../../../assets/icons/skills/after-effects-cc.png";
import davanciIco from "../../../assets/icons/skills/davinci-resolve-12.png";
import animateIco from "../../../assets/icons/skills/adobe-animate.png";
import flashIco from "../../../assets/icons/skills/adobe-flash-professional-cc-1.png";
import characterAnimeIco from "../../../assets/icons/skills/adobe-character-animator-icon-2020-.png";
import _3dsMaxIco from "../../../assets/icons/skills/3ds-Max.png";
/* *********** */

/* ENGLISH */
export const graphicDesignerCompEnglishData: HomeMainCompProps = {
  homeMainCompData: {
    label: "graphic-designer",
    title: "GRAPHIC DESIGNER",
    subtitle: "My skills as",
    img: coverImage,
    text: `These are my favourite tools 💖`,
    button: [],
    imgList: [],

    children: (
      <>
        <div className="skill-list">
          {/* UI and UX */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={adobeXdIcon} />
                </i>{" "}
                Adobe XD
              </li>
              <li>
                <i>
                  <img alt="image" src={figmaIco} />
                </i>{" "}
                Figma
              </li>
              <li>
                <i>
                  <img alt="image" src={libreOfficeDrawIco} />
                </i>{" "}
                Libre office draw
              </li>
            </ul>
            <footer
              className="skill-item-title"
              style={{ whiteSpace: "nowrap" }}
            >
              UI & UX <span style={{ color: "#6d78ad" }}>32.1%</span>{" "}
            </footer>
          </div>

          {/* Image */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={psIco} />
                </i>{" "}
                Photoshop
              </li>
              <li>
                <i>
                  <img alt="image" src={illustratorIco} />
                </i>{" "}
                Illustrator
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={zBrushIco}
                    style={{
                      filter: "invert(1)",
                    }}
                  />
                </i>{" "}
                ZBrush
              </li>
              <li>
                <i>
                  <img alt="image" src={sketchupIco} />
                </i>{" "}
                Sketchup
              </li>
            </ul>
            <footer className="skill-item-title">
              Image <span style={{ color: "#51cda0" }}>28.5%</span>{" "}
            </footer>
          </div>

          {/* Video */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={premiereProIco} />
                </i>{" "}
                Premiere pro
              </li>
              <li>
                <i>
                  <img alt="image" src={afterEffectIco} />
                </i>{" "}
                After effect
              </li>
              <li>
                <i>
                  <img alt="image" src={davanciIco} />
                </i>{" "}
                DaVinci Resolve
              </li>
            </ul>
            <footer className="skill-item-title">
              Video <span style={{ color: "#df7970" }}>14.3%</span>{" "}
            </footer>
          </div>

          {/* Extra */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={animateIco} />
                </i>{" "}
                Animate pro
              </li>
              <li>
                <i>
                  <img alt="image" src={flashIco} />
                </i>{" "}
                Adobe flash
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={characterAnimeIco}
                    style={{ border: "#9999ff solid 1px" }}
                  />
                </i>{" "}
                Character animator
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={_3dsMaxIco}
                    style={{ filter: "brightness(140%)" }}
                  />
                </i>{" "}
                3DS max
              </li>
            </ul>
            <footer className="skill-item-title">
              Animation <span style={{ color: "#4c9ca0" }}>25.1%</span>{" "}
            </footer>
          </div>
        </div>
      </>
    ),
  },
};

/* FRENCH */
export const graphicDesignerCompFrenchData: HomeMainCompProps = {
  homeMainCompData: {
    label: "graphic-designer",
    title: "GRAPHIC DESIGNER",
    subtitle: "En tant que",
    img: coverImage,
    text: `Voici mes outils préférés 💖`,
    button: [],
    imgList: [],

    children: (
      <>
        <div className="skill-list">
          {/* UI and UX */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={adobeXdIcon} />
                </i>{" "}
                Adobe XD
              </li>
              <li>
                <i>
                  <img alt="image" src={figmaIco} />
                </i>{" "}
                Figma
              </li>
              <li>
                <i>
                  <img alt="image" src={libreOfficeDrawIco} />
                </i>{" "}
                Libre office draw
              </li>
            </ul>
            <footer
              className="skill-item-title"
              style={{ whiteSpace: "nowrap" }}
            >
              UI & UX <span style={{ color: "#6d78ad" }}>32.1%</span>{" "}
            </footer>
          </div>

          {/* Image */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={psIco} />
                </i>{" "}
                Photoshop
              </li>
              <li>
                <i>
                  <img alt="image" src={illustratorIco} />
                </i>{" "}
                Illustrator
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={zBrushIco}
                    style={{
                      filter: "invert(1)",
                    }}
                  />
                </i>{" "}
                ZBrush
              </li>
              <li>
                <i>
                  <img alt="image" src={sketchupIco} />
                </i>{" "}
                Sketchup
              </li>
            </ul>
            <footer className="skill-item-title">
              Image <span style={{ color: "#51cda0" }}>28.5%</span>{" "}
            </footer>
          </div>

          {/* Video */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={premiereProIco} />
                </i>{" "}
                Premiere pro
              </li>
              <li>
                <i>
                  <img alt="image" src={afterEffectIco} />
                </i>{" "}
                After effect
              </li>
              <li>
                <i>
                  <img alt="image" src={davanciIco} />
                </i>{" "}
                DaVinci Resolve
              </li>
            </ul>
            <footer className="skill-item-title">
              Video <span style={{ color: "#df7970" }}>14.3%</span>{" "}
            </footer>
          </div>

          {/* Extra */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={animateIco} />
                </i>{" "}
                Animate pro
              </li>
              <li>
                <i>
                  <img alt="image" src={flashIco} />
                </i>{" "}
                Adobe flash
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={characterAnimeIco}
                    style={{ border: "#9999ff solid 1px" }}
                  />
                </i>{" "}
                Character animator
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={_3dsMaxIco}
                    style={{ filter: "brightness(140%)" }}
                  />
                </i>{" "}
                3DS max
              </li>
            </ul>
            <footer className="skill-item-title">
              Animation <span style={{ color: "#4c9ca0" }}>25.1%</span>{" "}
            </footer>
          </div>
        </div>
      </>
    ),
  },
};
